// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__BLVqe","heading":"styles_heading__lQJz0","msg":"styles_msg__SH4Ix"};